<template>

	<div class="g-display-list-filtering__item g-display-list-filtering__sort-by">
		<ul v-if="sorting" class="g-form-list">
			<li class="g-form-list__item">
				<label class="g-form-label" :for="'sort-by' + labelUid">Sort By<span class="g-display-list-filtering__sort-by-icon u-icon-chevron-down" aria-hidden="true"></span></label>
				<div class="g-form-select">
					<select v-model="sortBy" :id="'sort-by' + labelUid" class="g-form-select__dropdown-display">
						<option v-for="option in sorting.options" :key="option.label" :value="option.label">
							{{ option.label }}
						</option>
					</select>
				</div>
				<div class="g-display-list-filtering__sort-by-option">
					{{sortBy}}
				</div>
			</li>
		</ul>
	</div>

</template>

<script>
	import Search from '../../Search';
	import uid from '@mvps-genesis/uid';

	// create helper function for finding active options OR first if none are active
	function getActiveOption(options) {
		if (!options) {
			return null;
		}

		const found = options.find((option) => option.active);

		return (found) ? found.label : options[0].label;
	}

	export default {
		props: {
			sorting: {
				default() {
					return {};
				}
			},
		},
		data() {
			return {
				sortBy: getActiveOption(this.sorting.options),
				classes: '',
				labelUid: uid()
			}
		},
		watch: {
			sorting(sorting) {
				if (sorting.options && sorting.options.length > 0) {
					this.sortBy = getActiveOption(this.sorting.options);
				}

			},
			sortBy(label, oldLabel) {
				if (oldLabel == null) {
					return;
				}

				const option = this.sorting.options.find((o) => {
					return (o.label === label);
				});

				if (option) {
					Search.client
						.sort(option.field, option.direction)
						.search();
				}
			}
		}
	}
</script>
